<template>
  <div>
    <Gnb v-if="showGnb" />

    <Wait v-if="getItemMode()=='NUMBER'" />
    <Playground v-if="getItemMode()=='PLAY'" />
    <Result v-if="getItemMode()=='CONFIRM'" />
    <ResultPoll v-if="getItemMode()=='POLLSTAT'" />

    <Rank v-if="getItemMode()=='RANK'" />
    <FinalRank v-if="getItemMode()=='FINALRANK'" />
  </div>
</template>

<script>
import Wait from "@/components/item/Wait";
import Playground from "@/components/item/Playground";
import Result from "@/components/item/Result";
import ResultPoll from "@/components/item/ResultPoll";
import Rank from "@/components/item/Rank";
import FinalRank from "@/components/item/FinalRank";
import Gnb from "@/components/Gnb";
export default {
  components: { Wait, Playground, Result, Rank, FinalRank, Gnb, ResultPoll },
  computed: {
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    itemMode: {
      cache: false,
      get: function() {
        return this.$store.state.itemMeta.__page__;
      }
    }
  },
  methods: {
    getItemMode() {
      return this.$store.state.itemMeta.__page__;
    }
  }
};
</script>


<style lang="scss">
.quizWrap {
  padding: 85px 20px 30px;
  text-align: center;
  min-height: 100vh;
}

.quiz {
}
.quizTitle {
  font-size: 20px;
  color: #ffffff;
  margin-top: 15px;
  word-break: keep-all;
  font-family: "NotoKrM";
  line-height: 1.2em;
  font-weight: 500;
}

.quiz .exampleWrap {
  font-size: 0;
  margin-top: 29px;
}

.quiz .example {
  display: inline-block;
  vertical-align: top;
  margin: 15px 0 0 4%;
  width: 48%;
  position: relative;
  background: #ffffff;
  height: 120px;
  border-radius: 10px;
  box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.3);
}

.quiz .example:nth-child(2n + 1) {
  margin-left: 0;
}
.quiz .example:nth-child(1),
.quiz .example:nth-child(2) {
  margin-top: 0;
}
.quiz .example > input[type="checkbox"] {
  display: none;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.quiz .example label {
  border-radius: 10px;
  display: block;
  width: 100%;
  height: 100%;
  border: 3px solid #fff;
  padding: 23px 5% 0;
}

.quiz .example .num {
  display: inline-block;
  width: 35px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  background: #514f50;
  font-size: 13px;
  border-radius: 7px 7px 0 7px;
  position: absolute;
  left: -1px;
  top: -5px;
}
.quiz .example .text {
  color: #000000;
  font-size: 14px;
  text-align: left;
}
.quiz .example .img {
}
.quiz .example .img img {
  max-width: 125px;
  max-height: 75px;
}

.quiz .example > input:checked + label {
  border: 3px solid #1f5250;
}
.quiz .example > input:checked + label .num {
  background: #1f5250;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
}

.quiz .exampleWrap.text_ex .example {
  display: block;
  width: 100%;
  margin-left: 0;
  margin-top: 15px;
  height: auto;
}
.quiz .exampleWrap.text_ex .example label {
  padding: 15px 45px;
}

a.submitbtn {
  margin-top: 30px;
  border-radius: 9px;
  display: block;
  height: 45px;
  line-height: 45px;
  background: #193231;
  text-align: center;
  color: #fff;
  font-size: 14px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
}
a.submitbtn span {
  width: 27px;
  height: 27px;
  line-height: 27px;
  background: #ffffff;
  border-radius: 100%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: -3px;
}
a.submitbtn img {
  width: 15px;
}
.result a.submitbtn {
  opacity: 0.2;
}

.example.empty {
  background: rgba(255, 255, 255, 0.1);
  text-align: center;
  line-height: 120px;
  box-shadow: none;
}
.example.empty img {
  width: 80px;
}

.resultWrap {
}
.resultWrap .icon {
}
.resultWrap .icon img {
  width: 150px;
  margin-top: 25px;
}
.resultWrap h4 {
  color: #ffffff;
  font-size: 18px;
  line-height: 1em;
  margin-top: 20px;
}

.result .exampleWrap {
}
.result .exampleWrap .example {
  opacity: 0.5;
}
.result .exampleWrap .example.checked {
  opacity: 1;
  background: yellowgreen;
}
.result .exampleWrap .example.answer {
  opacity: 1 !important;
}

.result .exampleWrap .example.answer > input + label {
  border: 5px solid #5239ea;
}
.result .exampleWrap .example.answer:before {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  background: url("../../assets/img/answer_circle.png") no-repeat center center;
  width: 30px;
  height: 30px;
  background-size: 100%;
  margin: -15px 0 0 -15px;
  z-index: 2;
}
.result .exampleWrap .example.answer .num {
  background: #5239ea;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
}
.result .exampleWrap .example.answer .num img {
  width: 15px;
  margin-top: -5px;
}

/* 현재 순위 */

.nowRank {
  text-align: center;
  background: url("../../assets/img/rank_bg.png") no-repeat center top;
  padding-top: 120px;
  min-height: 100vh;
}

.nowRank .scoreWrap {
}
.nowRank .scoreWrap > div {
  display: inline-block;
  vertical-align: middle;
}
.nowRank .scoreWrap > div.left {
  text-align: center;
  margin-right: 7px;
}
.nowRank .scoreWrap > div.left h6 {
  color: rgba(255, 255, 255, 0.4);
  font-size: 8px;
  font-weight: 700;
  line-height: 1em;
}
.nowRank .scoreWrap > div.left h5 {
  color: #fff;
  font-size: 16px;
  line-height: 1em;
}
.nowRank .scoreWrap > div.right b {
  color: #ffffff;
  font-size: 25px;
  margin-top: 15px;
  margin-left: 5px;
  display: inline-block;
  vertical-align: top;
}
.nowRank .scoreWrap > div.right span {
  color: #ffffff;
  font-size: 65px;
  line-height: 1em;
  font-weight: 900;
  font-family: "NotoKrB";
  text-shadow: 1px 1px 7px rgba(0, 0, 0, 0.2);
}

.nowRank .icon {
  text-align: center;
  margin-top: 20px;
}
.nowRank .icon img {
  width: 243px;
}

.nowRank .info {
  width: 90%;
  margin: 30px auto 0;
  background: #243d3c;
  border-radius: 10px;
}
.nowRank .info ul {
  font-size: 0;
  padding: 20px 0;
}
.nowRank .info ul li {
  display: inline-block;
  vertical-align: top;
  width: 33.33%;
  border-left: 1px solid #3b7a78;
}
.nowRank .info ul li:first-child {
  border-left: none;
}
.nowRank .info ul li h3 {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1em;
}
.nowRank .info ul li:first-child h3 {
  color: #00cac2;
}
.nowRank .info ul li p {
  color: #ffffff;
  font-size: 12px;
  margin-top: 16px;
  line-height: 1em;
}

/* 최종 순위 */

.lastRank {
  padding-top: 120px;
  min-height: 100vh;
  z-index: 11;
  position: relative;
}
.lastRank .rank {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}
.lastRank .bg {
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.lastRank .rank .info {
  position: relative;
  position: absolute;
  top: 110px;
  left: 0%;
  width: 100%;
  z-index: 4;
  padding-left: 5%;
}
.lastRank .rank .trophy {
  position: relative;
  z-index: 3;
  display: none;
}
.lastRank .rank.toprank .trophy {
  display: block;
}
.lastRank .rank .infobg {
  position: relative;
}
.lastRank .rank .trophy img {
  width: 95%;
}
.lastRank .rank .infobg img {
  width: 100%;
}

.lastRank .rank .infobg img.topRankimg {
  display: none;
}
.lastRank .rank .infobg img.otherRankimg {
  display: block;
}

.lastRank .rank.toprank .infobg img.topRankimg {
  display: block;
}
.lastRank .rank.toprank .infobg img.otherRankimg {
  display: none;
}

.lastRank .rank .infobox {
  position: absolute;
  left: 50%;
  top: 125px;
  width: 57%;
  transform: translateX(-50%);
  margin-left: 0%;
  text-align: center;
}
.lastRank .rank .infobox {
  top: 110px;
}
.lastRank .rank .infobox > div {
  display: inline-block;
  vertical-align: middle;
}
.lastRank .rank .infobox .left {
  margin-right: 10px;
}
.lastRank .rank .infobox .left h6 {
  font-size: 8px;
  line-height: 1em;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
}
.lastRank .rank .infobox .left h5 {
  color: #fff;
  font-size: 16px;
  line-height: 1em;
  margin-top: 5px;
}

.lastRank .rank .infobox .right {
}
.lastRank .rank .infobox .right span {
  color: #ffffff;
  font-size: 65px;
  font-weight: 700;
  display: inline-block;
  vertical-align: top;
  line-height: 1em;
}
.lastRank .rank .infobox .right b {
  font-size: 25px;
  color: #ffffff;
  margin-top: 20px;
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  line-height: 1em;
}

.lastRank .rank .infobox > p {
  display: block;
  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  font-weight: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 5px;
  margin-top: 3px;
  font-family: "NotoKrL";
}
.lastRank .rank .infobox ul {
  font-size: 0;
  margin-top: 10px;
}
.lastRank .rank .infobox ul li {
  display: inline-block;
  vertical-align: top;
  width: 33.33%;
}
.lastRank .rank .infobox ul li h3 {
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
  font-weight: 700;
  line-height: 1em;
}
.lastRank .rank .infobox ul li:first-child h3 {
  color: #00cac2;
}
.lastRank .rank .infobox ul li p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  margin-top: 10px;
  line-height: 1em;
}

.lastRank .rank .survivorRank {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-top: 14%;
}
.lastRank .rank .survivorRank h5 {
  color: #ffffff;
  font-size: 12px;
  width: 77px;
  height: 24px;
  line-height: 24px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  text-align: center;
  margin: 0 auto;
}
.lastRank .rank .survivorRank h3 {
  color: #ffffff;
  font-size: 30px;
  margin-top: 10px;
}
.lastRank .rank .survivorRank p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  font-weight: 100;
}

/* 라이브 퀴즈 */

.survivorWrap_start {
  padding: 85px 5% 0;
  text-align: center;
  min-height: 100vh;
}

.survivorWrap_start h3 {
  margin-top: 12px;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  font-weight: 700;
}
.survivorWrap_start .img {
  margin-top: 25px;
  padding: 6px;
  background: #ffffff;
  box-shadow: 1px 1px 11px 5px rgba(0, 0, 0, 0.5);
}
.survivorWrap_start .img img {
  width: 100%;
}
.survivorWrap_start p {
  color: #ffffff;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  line-height: 1.7em;
  margin-top: 30px;
}
.survivorWrap_start p span {
  font-size: 24px;
}
.survivorWrap_start a {
  margin: 25px auto 0;
  display: block;
  background: #193231;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  border-radius: 25px;
  width: 75%;
}
.survivorWrap_start a span {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #ffffff;
  border-radius: 100%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  margin-top: -3px;
}
.survivorWrap_start a img {
  width: 12px;
  margin-top: -3px;
}

.survivorWrap_start .icon {
  margin-top: 30px;
}
.survivorWrap_start .icon img {
  width: 31%;
}
.livepollWrap .icon {
  margin-top: 40px;
}
.livepollWrap .icon img {
  margin-left: -5%;
  width: 27%;
}
.survivorWrap_start a.disable {
  opacity: 0.35;
}

.survivorWrap_start.result {
  padding: 30px 5% 0;
  text-align: center;
  min-height: 100vh;
  background: #3d3d3e;
}

.survivorWrap_start.result h3 {
  margin-top: 17px;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  font-weight: 100;
}
.survivorWrap_start.result .img {
  margin-top: 25px;
  padding: 6px;
  background: #ffffff;
  box-shadow: 1px 1px 11px 5px rgba(0, 0, 0, 0.5);
}
.survivorWrap_start.result .img img {
  width: 100%;
}
.survivorWrap_start.result p {
  color: #ffffff;
  font-size: 13px;
  font-weight: 300;
  text-align: center;
  line-height: 1em;
  margin-top: 5px;
}

.survivorWrap_start a img {
  width: 12px;
  margin-top: -3px;
}

.survivorWrap_start.result .icon {
  margin-top: 25px;
}
.survivorWrap_start.result .icon img {
  width: 45%;
}

.survivorWrap_start a.disable {
  opacity: 0.35;
}

.survivorWrap_start .info {
  width: 90%;
  margin: 38px auto 0;
  background: #646465;
  border-radius: 10px;
}
.survivorWrap_start .info ul {
  font-size: 0;
  padding: 20px 0;
}
.survivorWrap_start .info ul li {
  display: inline-block;
  vertical-align: top;
  width: 33.33%;
  border-left: 1px solid #a2a2a3;
}
.survivorWrap_start .info ul li:first-child {
  border-left: none;
}
.survivorWrap_start .info ul li h3 {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1em;
  margin-top: 0;
}
.survivorWrap_start .info ul li p {
  color: #ffffff;
  font-size: 12px;
  margin-top: 16px;
  line-height: 1em;
}

.waiting {
  min-height: 100vh;
  padding: 85px 5% 0;
  text-align: center;
  min-height: 100vh;
}
.waiting > h3 {
  color: #ffffff;
  font-size: 16px;
  margin-top: 28px;
}
.waiting > .icon {
  width: 70px;
  margin: 0 auto;
}
.waiting > .icon img {
  width: 100%;
}

.waiting .box {
  display: block;
  height: 60px;
  padding-top: 10px;
  width: 33.3%;
  position: relative;
  /*margin:0 -4px -5px -2px;*/
  transition: all 0.2s ease;
  margin: 0 auto;
}

/* -------------- loader10 -------------- */

.loader10:before {
  content: "";
  position: absolute;
  top: 0px;
  left: -14px;
  height: 6px;
  width: 6px;
  border-radius: 6px;
  -webkit-animation: loader10g 3s ease-in-out infinite;
  animation: loader10g 3s ease-in-out infinite;
}

.loader10 {
  position: relative;
  width: 6px;
  height: 6px;
  top: 46%;
  left: 46%;
  border-radius: 6px;
  -webkit-animation: loader10m 3s ease-in-out infinite;
  animation: loader10m 3s ease-in-out infinite;
}

.loader10:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 14px;
  height: 6px;
  width: 6px;
  border-radius: 6px;
  -webkit-animation: loader10d 3s ease-in-out infinite;
  animation: loader10d 3s ease-in-out infinite;
}

@-webkit-keyframes loader10g {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 1);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
@keyframes loader10g {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 1);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

@-webkit-keyframes loader10m {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  50% {
    background-color: rgba(255, 255, 255, 1);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
@keyframes loader10m {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  50% {
    background-color: rgba(255, 255, 255, 1);
  }
  75% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

@-webkit-keyframes loader10d {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 1);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
@keyframes loader10d {
  0% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  25% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  75% {
    background-color: rgba(255, 255, 255, 1);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

footer .logo {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 3%;
  left: 0;
}
footer .logo img {
  width: 108px;
}

.ex_checkWrap {
  margin-top: 40px;
}
.ex_check {
}
.ex_check .stat {
}
.ex_check .stat > div {
}
.ex_check .stat > div.num {
}
.ex_check .stat > div.stat_head {
}

.ex_check .stat {
  vertical-align: top;
  margin: 15px 0 0 0%;
  width: 100%;
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.3);
}

.ex_check .stat:nth-child(1) {
  margin-top: 0;
}
.ex_check .stat .num {
  display: inline-block;
  width: 35px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  background: #514f50;
  font-size: 13px;
  border-radius: 7px 7px 0 7px;
  position: absolute;
  left: -1px;
  top: -5px;
}
.ex_check .stat.top .num {
  background: #1f5250;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
}

.ex_check .stat .stat_head {
  border-bottom: 1px solid #ebebeb;
}
.ex_check .stat .stat_head > div {
  padding: 12px 25px 12px 45px;
  text-align: left;
}
.ex_check .stat .stat_head > div img {
  max-width: 123px;
  max-height: 75px;
}
.ex_check .stat .stat_head > div.text {
  color: #000000;
  font-size: 14px;
  text-align: left;
}
.ex_check .stat .stat_body {
  font-size: 0;
  padding: 12px 0;
}
.ex_check .stat .stat_body > div {
  display: inline-block;
  vertical-align: top;
}
.ex_check .stat .stat_body .per {
  font-size: 13px;
  color: #8d8d8d;
  font-size: 13px;
  width: 50px;
  padding-left: 7px;
  text-align: left;
  line-height: 15px;
}
.ex_check .stat .stat_body .progress {
  width: calc(100% - 120px);
  text-align: left;
  position: relative;
}
.ex_check .stat .stat_body .progress .bar {
  background: #1c4488;
  display: inline-block;
  min-width: 7px;
  border-radius: 0 7.5px 7.5px 0;
  height: 15px;
}

.ex_check .stat .stat_body .progress .img {
  display: none;
  position: absolute;
  right: -40px;
  top: -35px;
  width: 50px;
}
.ex_check .stat.top .stat_body .progress .img {
  display: block;
}
.ex_check .stat .stat_body .progress .img img {
  width: 100%;
}
.ex_check .stat .stat_body .people {
  font-size: 13px;
  color: #8d8d8d;
  font-size: 12px;
  width: 70px;
  text-align: right;
  padding-right: 7px;
  line-height: 15px;
}
.ex_check .stat .stat_body .people span {
  font-size: 16px;
  color: #1c4488;
  font-weight: 700;
}

.qnaWrap {
  padding: 85px 5% 60px;
  text-align: center;
  min-height: 100vh;
}
/* .qnaWrap .qnaView{
    position: relative;
    padding: 15px 15px 40px 15px;
    background: #ffffff;
    border-radius:10px ;
    box-shadow: 1px 1px 10px 1px rgba(0,0,0,0.3);
} */
.qnaWrap .qnaView .qnaViewTitle {
  font-size: 0;
}
.qnaWrap .qnaView .qnaViewTitle > * {
  display: inline-block;
  vertical-align: top;
  width: 50%;
}
.qnaWrap .qnaView .qnaViewTitle h3 {
  color: #000000;
  font-size: 13px;
  text-align: left;
}
.qnaWrap .qnaView .qnaViewTitle p {
  color: #666666;
  font-size: 13px;
  text-align: right;
}
.qnaWrap .qnaView .qnaViewTitle p img {
  width: 18px;
  margin-top: -4px;
}

.qnaWrap .qnaView .qnaViewCon {
  margin-top: 15px;
  text-align: left;
  font-size: 13px;
  color: #666666;
}
.qnaWrap .qnaView .qnaViewCon span {
  color: #cdcdcd;
  font-size: 11px;
  position: absolute;
  right: 15px;
  bottom: 15px;
}

.qnaWrap .qnaComment {
  margin: 10px auto 0;
  width: 90%;
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.3);
}
.qnaWrap .qnaComment .qnaCommentTitle {
  color: #666666;
  font-size: 13px;
  text-align: left;
  background: #e0e3e3;
  padding: 10px 15px;
}
.qnaWrap .qnaComment .qnaCommentTitle img {
  width: 17px;
  margin-right: 3px;
  margin-top: -3px;
}
.qnaWrap .qnaComment .qnaCommentTitle span {
  color: #666666;
  font-size: 13px;
  font-weight: 700;
  margin-left: 5px;
}

.qnaWrap .qnaComment ul {
  padding: 0 15px;
}
.qnaWrap .qnaComment ul li {
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0;
  text-align: left;
  position: relative;
}
.qnaWrap .qnaComment ul li .text {
  position: relative;
}
.qnaWrap .qnaComment ul li .text h3 {
  color: #000;
  font-size: 13px;
  font-weight: 700;
  padding-right: 50px;
}
.qnaWrap .qnaComment ul li .text p {
  color: #666666;
  font-size: 13px;
  margin-top: 5px;
  padding-right: 50px;
}
.qnaWrap .qnaComment ul li .text a {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  display: block;
  height: 40px;
}
.qnaWrap .qnaComment ul li .text a img {
  width: 100%;
}

.qnaWrap .qnaComment > a {
  color: #cccccc;
  font-size: 14px;
  padding: 10px 0;
  display: block;
}
.qnaWrap .qnaComment > a img {
  width: 14px;
  margin-left: 5px;
  margin-top: -2px;
}

.commentWrite {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 7px 0;
  background: #0f1e28;
  width: 100%;
  text-align: center;
}
.commentWrite input {
  width: 74%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid #f4f1f1;
  background: #fff;
  padding: 0 10px;
  border-radius: 5px;
  height: 35px;
  font-size: 13px;
}
.commentWrite a {
  width: 15%;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  background: #747474;
  height: 35px;
  line-height: 35px;
  margin-left: 1%;
  font-size: 13px;
  color: #ffffff;
}

.qnaWrap.list-style {
  background: #0099c1;
  padding-left: 0;
  padding-right: 0;
}
.qnalistWrap {
}
.qnalistTitle {
  border-bottom: 1px solid #282828;
  padding-bottom: 20px;
  margin-bottom: 20px;
  position: relative;
}
.qnalistTitle .num {
  width: 38px;
  height: 38px;
  border-radius: 100%;
  text-align: center;
  line-height: 35px;
  color: #fff;
  font-size: 15px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  margin: 0 auto;
}
.qnalistTitle .title > a {
  color: #ffffff;
  font-size: 18px;
  width: 80%;
  margin: 8px auto 0;
  display: block;
  word-break: keep-all;
}
.qna_kind_list {
  position: absolute;
  left: 5%;
  top: 0;
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 90%;
  z-index: 2;
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.5);
}
.qna_kind_list ul {
}
.qna_kind_list ul li {
  padding: 10px;
  text-align: left;
  border-top: 1px solid #e5e5e5;
}
.qna_kind_list ul li:first-child {
  border-top: none;
}
.qna_kind_list ul li a {
  font-size: 0;
  display: block;
  position: relative;
}

.qna_kind_list ul li a .number {
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  width: 24px;
  color: #fff;
  background: #eaa4bc;
  border-radius: 100%;
  font-size: 16px;
  text-align: center;
}
.qna_kind_list ul li h3 {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 24px);
  padding: 0 30px 0 10px;
  font-size: 14px;
}
.qna_kind_list ul li .arrow {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.qna_kind_list ul li .arrow img {
  width: 18px;
}

.qnalistCon {
}
.qnalistCon li .qnatitle {
  font-size: 0;
  padding: 10px 15px;
  background: #3b3b3b;
}
.qnalistCon li .qnatitle > * {
  display: inline-block;
  vertical-align: top;
  width: 50%;
}
.qnalistCon li .qnatitle h3 {
  color: #ffffff;
  font-size: 13px;
  text-align: left;
}
.qnalistCon li .qnatitle p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  text-align: right;
  font-weight: 100;
  font-family: "NotoKrL";
}
.qnalistCon li .qnatitle p span {
  margin-right: 5px;
}

.qnalistCon li .con {
  padding: 15px;
  text-align: left;
  background: #ffffff;
}
.qnalistCon li .con > p {
  font-size: 13px;
  color: #666666;
}
.qnalistCon.qnaList li .con > p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3em;
  width: 100%;
  height: 2.6em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qnalistCon li .con .info {
  margin-top: 15px;
  font-size: 0;
}
.qnalistCon li .con .info > div {
  display: inline-block;
  vertical-align: top;
  width: 50%;
}
.qnalistCon li .con .info div.left a {
  font-size: 13px;
  color: #999999;
  margin-right: 25px;
}
.qnalistCon li .con .info div.left a img {
  width: 15px;
  margin-top: -3px;
  margin-right: 5px;
}
.qnalistCon li .con .info div.right {
  text-align: right;
}
.qnalistCon li .con .info div.right a.modify img {
  height: 20px;
}
.qnalistCon li .con .info div.right a.delete {
  margin-left: 13px;
}
.qnalistCon li .con .info div.right a.delete img {
  height: 20px;
}
.qnalistCon li .con .info div.right a img {
  vertical-align: top;
}

.qnaWrap .alertM {
  display: none;
  padding: 15px;
  background: #e7e7e7;
  border-radius: 8px;
  margin-top: 15px;
  text-align: center;
  font-size: 0;
}
.qnaWrap .alertM p {
  color: #666666;
  font-size: 13px;
  margin-bottom: 10px;
  line-height: 1em;
}
.qnaWrap .alertM a {
  display: inline-block;
  vertical-align: top;
  width: 60px;
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  border-radius: 4px;
  background: #747474;
}

.qnaWrap .alertM a.cancel {
  background: #a9a9a9;
  margin-left: 5px;
}

.qnalistCon li {
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  /* box-shadow: 1px 1px 10px 1px rgba(0,0,0,0.3); */
  width: 90%;
  margin: 10px auto;
  overflow: hidden;
}
.qnalistCon li:first-child {
  margin-top: 0;
}
.qnaWrap > .btnWrap {
  font-size: 0;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.moreWrap {
  text-align: center;
  position: relative;
  margin-top: 80px;
}
.moreWrap a.more {
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 50px;
  height: 50px;
}
.moreWrap a.more img {
  width: 13px;
  margin-left: 10px;
}
.moreWrap a.write {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  text-align: center;
  background: #440099;
  line-height: 50px;
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.3);
  display: block;
  position: fixed;
  right: 5%;
  bottom: 60px;
  z-index: 101;
}
.moreWrap a.write img {
  width: 20px;
  margin-top: -5px;
}
.qnaWrap > .btnWrap > a {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  height: 50px;
  line-height: 50px;
  background: #0f1e28;
  color: #ffffff;
}
.qnaWrap > .btnWrap > a:first-child {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}
.qnaWrap > .btnWrap > a img {
  width: 20px;
  margin-right: 10px;
  margin-top: -3px;
}
.qnaWrap > .btnWrap > a:first-child img {
  width: 23px;
}
.qnaWrap > .btnWrap > a.type2 {
  background: #4a5760;
}

.qnaWrap.list-style2 {
  padding: 50px 0;
  background: #282828;
}
.qnaChoice {
}
.qnaChoice ul {
}
.qnaChoice ul li {
  position: relative;
  margin-bottom: 2px;
}
.qnaChoice ul li a {
  padding: 40px 5%;
  display: block;
  text-align: left;
  font-size: 0;
}
.qnaChoice ul li a .num {
  display: inline-block;
  vertical-align: middle;
  height: 38px;
  line-height: 33px;
  width: 38px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 100%;
  font-size: 15px;
  text-align: center;
}
.qnaChoice ul li a h3 {
  color: #ffffff;
  font-size: 17px;
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 38px);
  padding-left: 20px;
  padding-right: 40px;
}
.qnaChoice ul li a .arrow {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}
.qnaChoice ul li a .arrow img {
  width: 15px;
}

.qnaWrite {
  position: relative;
  background: #ffffff;
  border-radius: 10px;
  /* box-shadow: 1px 1px 10px 1px rgba(0,0,0,0.3); */
  width: 90%;
  margin: 10px auto;
  overflow: hidden;
  padding: 15px;
}
.qnaWrite .qnaWriteTitle {
  font-size: 0;
  margin-bottom: 15px;
}
.qnaWrite .qnaWriteTitle h3 {
  color: #000000;
  font-size: 13px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
  width: 50%;
}
.qnaWrite .qnaWriteTitle h3 span {
  color: #666666;
  margin-left: 5px;
}
.qnaWrite .qnaWriteTitle .checkbox {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  text-align: right;
}
.qnaWrite .qnaWriteTitle .checkbox label {
  font-size: 13px;
  line-height: 20px;
}
.qnaWrite .qnaWriteTitle .checkbox input[type="checkbox"] + label:before {
  vertical-align: top;
  margin-right: 10px;
}
.qnaWrite .qnaWriteCon {
  position: relative;
}
.qnaWrite .qnaWriteCon textarea {
  width: 100%;
  border: 1px solid #f4f1f1;
  background: #ffffff;
  border-radius: 4px;
  padding: 15px;
  resize: vertical;
  font-size: 13px;
  height: 180px;
}
.qnaWrite .qnaWriteCon textarea::placeholder {
  color: #cdcdcd;
}
.qnaWrite .qnaWriteCon textarea.error {
  color: #4087e8;
  border: 1px solid #4087e8;
}
.qnaWrite .qnaWriteCon textarea.error::placeholder {
  color: #4087e8;
}
.qnaWrite .qnaWriteCon .count {
  position: absolute;
  right: 15px;
  bottom: 15px;
  color: #cdcdcd;
  font-size: 11px;
}
.qnaWrite .qnaWriteCon .count b {
  color: #cdcdcd;
  font-size: 11px;
}
</style>
